import {useState, useEffect} from 'react'
import {PPP001} from "./PPP001"
import {MathJaxContext } from "better-react-mathjax";
import {Chargement} from "./Chargement"
import {shuffleArray} from "../Fonctions"
import {SignalQuestion} from "./SignalQuestion"


function shuffleTest(array) {
  //let tab = []
  let labels = document.querySelectorAll('label')
  //const elt = labels[1]
  let div = document.querySelector('.qcm')
  if(div) {
    div.appendChild(labels[0])
    for (let i=0; i<labels.length; i++) {
      div.appendChild(labels[Math.round(Math.random()*(labels.length-1))])
    }
    document.querySelectorAll('input[type=checkbox')?.forEach(e=>e.checked=false)
    document.querySelectorAll('input[type=radio')?.forEach(e=>e.checked=false)
  }
}


export function AAA002 ({auth, tab, setTab, setShow_activite, mode_classe=false, id_question}) {
  //console.log('tab : ', tab)
  let rep_tab = []

  const [data_eval, setData_eval] = useState({
    page:0,
    note:0,
    note_finale:0,
    rep:[],
    brep:false,
    bchbx:[],
    mchbx:[],
    currep:false,
    struggled:false,
    n:1,
    erreur:'',
    elt_co:false,
    img_max:false,
    scrollable:false,
    signalQuestion:false,
  })

  const [msg, setMsg] = useState({
    btn:'Valider',
    type:'',
    msg:'',
    solution:'',
  })
  const reps = {}
  tab.forEach((q, k) => {
    let id_rep = k+''+Math.round(Math.random()*99)
    if(Array.isArray(q[3])){
      q[3].forEach((rep, k0) => {
        id_rep = k+''+k0+''+Math.round(Math.random()*99)
        reps[id_rep] = rep
        if(k0 === 0) {data_eval.rep.push(id_rep)}
      })
    } else {
      reps[id_rep] = q[4]
      data_eval.rep.push(id_rep)
    }
  })

  useEffect(()=>{    
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
  },[tab, rep_tab])

  function IsScrollable () {
    let page_height = document.querySelector('.page')?.offsetHeight
    let modal_height = document.querySelector('.modal')?.offsetHeight
    return page_height > modal_height*0.75
  }

  useEffect(()=>{    
    shuffleTest()
    setData_eval({...data_eval, scrollable:IsScrollable()})
  },[tab, data_eval.page])


  const clrp = (rep) => rep.replaceAll(',', '.').replaceAll('é', 'e').replaceAll('è', 'e').replaceAll('à', 'a').replaceAll(' ', '').toLowerCase().trim()
  const aaaaa = () => {
    const goodCom = ['<img class="center" src="https://maths-au-quotidien.fr/images/automaths/smiley-pouce-vert.png" height="50">', '<img class="center" src="https://maths-au-quotidien.fr/images/automaths/smiley-yess.png" height="50">', 'Bravo ! ', 'Super !', 'Très bien !', 'Excellent !', '<span style="font-size:2em">😘</span>', '<span style="font-size:2em">😛</span>']
    shuffleArray(goodCom)
    setMsg({...msg, type:'success fadeout5', msg:goodCom[0], btn:'Suite'})
    setData_eval({...data_eval, note:data_eval.note + 1, n:data_eval.n + 1, note_finale:Math.round((data_eval.note + 1)*1000/data_eval.n)/10, brep:false})
  }
  const bbbbb = () => {
    const badCom = ['<img class="center" src="https://maths-au-quotidien.fr/images/automaths/smiley-pouce-rouge.png" height="50">', '<span style="font-size:2em">🙀</span>', '<span style="font-size:2em">😱</span>', 'Oups ... <span style="font-size:2em">😬</span>', '<span style="font-size:2em">😞</span>', 'Réponse non acceptée', 'Il faudra réessayer', 'Étourderie']//['Erreur ! ', 'Mauvaise réponse !', 'Faux !']
    const erreur = data_eval.erreur ? data_eval.erreur + '_' + id_question[data_eval.page] : id_question[data_eval.page]
    shuffleArray(badCom)
    let sols_affiche = ''
    if(Array.isArray(tab[data_eval.page][4])){
      sols_affiche = tab[data_eval.page][4].map(e=>(e+'').split('__')[0]).join(' et ')
    } else { sols_affiche = tab[data_eval.page][4] || 'de laisser le champ vide.'}
    setMsg({...msg, type:'danger fadeout5', msg:badCom[0], btn:'Suite', solution:sols_affiche})
    setData_eval({...data_eval, n:data_eval.n + 1, note_finale:Math.round((data_eval.note)*1000/data_eval.n)/10, erreur, signalQuestion:true})
  }
  const suite = () => {
    const input = document.querySelector('.reponse input[type=text]')
    if(input){input.value=''}
    const p = data_eval.page + 1
    setData_eval({...data_eval, page:p, struggled:false, bchbx:[], mchbx:[], signalQuestion:false, img_max:false})
    setMsg({...msg, msg:'', solution:'', btn:'Valider'})
    window.MathJax.typeset()
  }

  const handleClick = (e) => {
    //Traitement des checkbox0
    if(e.target.value === 'Valider' && Array.isArray(tab[data_eval.page][3]) && (tab[data_eval.page][3][tab[data_eval.page][3].length-1]+'') === 'checkbox0' && !data_eval.mchbx.length) {aaaaa();return}
    //Traitement des autres cas
    if(e.target.value === 'Valider') {data_eval.brep ? aaaaa() : bbbbb();return}
    if(e.target.value === 'Suite') {suite();return}
    setData_eval({...data_eval, brep:false, img_max:false})
  }
  const handleCheck = (e) => {
    e.target.checked = e.target.type === 'checkbox' ? e.target.checked : true
  }
  const handleCheckbox = (k, bonne_checkbox) => {
    if(!data_eval.bchbx.includes(k) && k < bonne_checkbox){data_eval.bchbx.push(k)}
    else if(data_eval.bchbx.includes(k) && k < bonne_checkbox){
      data_eval.bchbx = data_eval.bchbx.filter(e => e !== k)
    }
    if(!data_eval.mchbx.includes(k) && k >= bonne_checkbox){data_eval.mchbx.push(k)}
    else if(data_eval.mchbx.includes(k) && k >= bonne_checkbox){
      data_eval.mchbx = data_eval.mchbx.filter(e => e !== k)
    }
    
    if(data_eval.mchbx.length || data_eval.bchbx.length !== bonne_checkbox*1) {
      setData_eval({...data_eval, brep:false})
    } else {setData_eval({...data_eval, brep:true})}
    //console.log('k', k, 'bonne_checkbox', bonne_checkbox, 'bchbx', data_eval.bchbx, 'mchbx', data_eval.mchbx)
    //console.log(data_eval.bchbx.length)
    //console.log(bonne_checkbox)
    //console.log(data_eval.mchbx.length || data_eval.bchbx.length !== bonne_checkbox*1)
  }

  const handleRepField = (e) => {
    if(e.target.value === 'Suite') {suite();return}

    if(Array.isArray(tab[data_eval.page][4])){
      let valid_rep = true
      e.target.parentNode.querySelectorAll('input[type="text"]').forEach((rep_user, k) => {
        valid_rep = valid_rep && clrp(tab[data_eval.page][4][k]+'').split('__').includes(clrp(rep_user.value+''))
      })
      valid_rep ? aaaaa() : bbbbb()
    } else {
      const tab_rep = (tab[data_eval.page][4]+'').split('__').map(e => clrp(e))
      const rep_user = clrp(e.target.parentNode.querySelector('input[type="text"]').value)
      tab_rep.includes(rep_user) && rep_user || rep_user === tab_rep[0] ? aaaaa() : bbbbb()
    }
  }

  function Reponse (rep) {
    if (Array.isArray(rep) && (rep[rep.length-1]+'').slice(0,-1) === 'checkbox'){
      const bonne_checkbox = rep[rep.length-1].slice(-1)

      rep_tab = rep.map((elt, k)=> 
          !(elt+'').includes('checkbox') ? 
            <label key={k} className={k<bonne_checkbox && msg.btn==='Suite' ? 'green' : ''} onChange={handleCheck} > 
              <input name="rep" className="radio" type="checkbox" onClick={()=>handleCheckbox(k, bonne_checkbox)} /> {<span dangerouslySetInnerHTML={{ __html:elt.replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}}></span>
            }
            </label>
          :''
        )
      return <>
          <div className={'reponse qcm'+(rep.length === 4 ? ' c3' : '')}>
            {rep_tab}
          </div>
          {msg.msg ? <div className={'alert '+ msg.type} dangerouslySetInnerHTML={{ __html:'<br>'+msg.msg+'<br><br>'}}></div> : ''}
          <input className={'btn'+(msg.btn==='Suite'?' suite':'')} type="button" onClick={handleClick} value={msg.btn} /> 
        </>
    } else if (Array.isArray(rep)){
      rep_tab = rep.map((elt, k)=> 
          //!(elt+'').includes('checkbox') ? 
            <label key={k} className={k===0 && msg.btn==='Suite' ? 'green' : ''} onClick={k === 0 ? (e)=> {
                  if(e.target.type === 'radio'){setData_eval({...data_eval, brep:true})}
                } : handleClick}> 
              <input name="rep" className="radio" type="radio" onChange={handleCheck} /> {<span dangerouslySetInnerHTML={{ __html:(elt+'').replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}}></span>
            }
            </label>
          //:''
        )
      return <>
          <div className={'reponse qcm'+(rep.length === 3 ? ' c3' : '')}>
            {rep_tab}
          </div>
          {msg.msg ? <div className={'alert '+ msg.type} dangerouslySetInnerHTML={{ __html:'<br>'+msg.msg+'<br><br>'}}></div> : ''}
          <input className={'btn'+(msg.btn==='Suite'?' suite':'')} type="button" onClick={handleClick} value={msg.btn} /> 
        </>
    } else {
      return <>
        <div className="reponse" dangerouslySetInnerHTML={{ __html:rep.replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}}></div>
        {msg.msg ? <div className={'alert '+ msg.type} dangerouslySetInnerHTML={{ __html:'<br>'+msg.msg+'<br><br>'}}></div> : ''}
        <input className={'btn'+(msg.btn==='Suite'?' suite':'')} type="button" onClick={handleRepField} value={msg.btn} /> <br/>
        {msg.solution && <div className={'alert success'}><br/>La réponse était {(msg.solution+'').split('__')[0]}<br/><br/></div>}
        </>
    }
  }
 
  const elt_co = []
  tab.forEach(e => {
    if(e.length === 5){
      elt_co.push((e[4]+'').split('_')[0])
    }
    if(e.length === 4){
      if((''+e[3][e[3].length-1]).includes('checkbox')) {
        const n = e[3][e[3].length-1].slice(-1)
        let elt_rep = e[3][0]
        for (let i=1; i<n; i++) {
          elt_rep += ' et '+e[3][i]
        }
        elt_co.push(elt_rep)
      } else {elt_co.push(e[3][0])}
    } 
    
  })

 function ElementCorr ({nb}) {
    return <div className="page correc">
        {nb === 1 ? <div className="message center" dangerouslySetInnerHTML={{ __html:'<b>Réponse '+(data_eval.page+1)+'</b><br/><br/>'+elt_co[data_eval.page]}}>
          </div>
          : elt_co.map((e,k)=><div key={k} className="message" dangerouslySetInnerHTML={{ __html:'<b>Réponse '+(k+1)+'</b><br/><br/>'+e}}>
                              </div>
        )}
      </div>
  }

  //console.log(auth)
  //console.log(tab)
  //console.log(data_eval.erreur)
  return (
    <>
    {tab[data_eval.page] ? 
    <>
    <div className='mode_classe_content eleve'>
      <div className={'page'+ (data_eval.scrollable ? ' scrollable' : '')}>
      	<h1>{tab[data_eval.page][0]}</h1>
        {auth.replayable === '0' ? <div className="info fadeout5"><br/><b>Attention</b> : vous ne pouvez faire qu'un seul essai !<br/><br/> </div> : ''}
        <h2 dangerouslySetInnerHTML={{ __html:(data_eval.page+1)+'. '+tab[data_eval.page][1].replaceAll('*','⭐').replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}}></h2>
        <MathJaxContext>
          <div className="enonce">
        	 <span dangerouslySetInnerHTML={{ __html:tab[data_eval.page][2].replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/').replaceAll("center", data_eval.img_max ? "center max" : "center")}} onClick={e=>{
              //e.target.classList.toggle('max')
              if(tab[data_eval.page][2].includes('src="')){
                setData_eval({...data_eval, img_max:!data_eval.img_max, scrollable:IsScrollable()})
              }
              }} ></span>
          </div>
          {Reponse(tab[data_eval.page][3])}
        </MathJaxContext>
        {(data_eval.signalQuestion && auth.donne_par) && <SignalQuestion auth={auth} num_quest={auth.niveau+'_'+id_question[data_eval.page]} />}
      {mode_classe && <>
              <div className="precedent" onClick={()=>setData_eval({...data_eval, img_max:false, page:Math.max(0, data_eval.page-1)})}></div>
              <div className="suivant" onClick={()=>suite()}></div>
            </>}
        <div style={{position:'relative', textAlign:'right', color:'#bbb', bottom:'-20px', marginRight:'15px'}}>{auth.niveau.replace('maths', '').replace('-', '').replace('_pro', 'p').replace('spe', '').slice(0,5)+'_'+id_question[data_eval.page]}</div>
      </div>
        {data_eval.elt_co && <ElementCorr nb={1} />}
      
    </div>
      
    {(data_eval.page>=0 && auth.profil!=='Professeur') && <div align="center">{auth.prenom + ', votre taux de réussite est de '+data_eval.note_finale + ' %'}</div>}
    </>
    :(data_eval.page > 0 ? 
      <div className="mode_classe_content eleve">
      <PPP001 auth={{...auth, note:data_eval.note_finale}} setTab={setTab} setShow_activite={setShow_activite} data_eval={data_eval} setData_eval={setData_eval} />
        {data_eval.elt_co && <ElementCorr nb={10} />}

      </div>
      : <div className="dark"><Chargement/></div>)}
    
    </>
  );
}